import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, Injector } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../../../../../../visa';
import { pageFiltering, pageSorting } from '../../../../../../../listing.utils';
import { AutomatedPermissionWizardService, BranchService, CompanyService, LocationService, Pagination } from 'blg-akaun-ts-lib';
import { PermWizardSelectors } from '../../../../../../../modules/permission/permission-wizard-controller/selectors';
import { FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SearchQueryModel } from '../../../../../../../models/query.model';
import { PaginationComponent } from '../../../../../../../utilities/pagination/pagination.component';
import { targetSearchModel, TARGET_TABLES } from '../../../../models/target-search.model';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-targets',
    templateUrl: './targets.component.html',
    styleUrls: ['./targets.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ComponentStore]
  })
export class TargetsComponent implements OnInit, OnDestroy{
  @Input() localState;
  @Output() permLine = new EventEmitter();
  @ViewChild(PaginationComponent) paginationComp: PaginationComponent;

  targetTable = '';
  searchModel = targetSearchModel;
  targetService;
  pagination = new Pagination();
  // Criteria from the search bar, applied by setGridData alongside the scoping
  // the target listing always carries.
  searchCriteria: any[] = [];
  appletGuid = sessionStorage.getItem('appletGuid');
  // initialise ag grid state
  gridApi;
  defaultColDef = {
    filter: 'agTextColumnFilter',
    sortable: true,
    minWidth: 200,
    flex: 2,
    resizable: true,
    suppressCsvExport: true,
    wrapText: true,
    autoHeight: true,
  };

  columnsDefs;
  permissionTemplateGuid;
  companyGuid: any[] = [];
  locationGuid: any[] = [];
  branchGuid: any[] = [];
  autoCreate:boolean;

  selectedRow = [];

  // api visa
  apiVisa = AppConfig.apiVisa;
  public form: FormGroup;

  private subs = new SubSink();

  //translation variable
  perm_set_prefix_text: string;
  generate_permission_sets_text: string;
  role_prefix_text: string;
  auto_create_roles_text: string;
  select_all_text: string;
  code_text: string;
  name_text: string;

  constructor(
    private readonly store: Store,
    private permissionWizardService: AutomatedPermissionWizardService,
    private branchService: BranchService,
    private companyService: CompanyService,
    private locationService: LocationService,
    private toastr: ToastrService,
    private injector: Injector
  ) {
    const translateService = this.injector.get(TranslateService, null);
    if (translateService) {
      translateService.get('labels').subscribe(res => {
        this.perm_set_prefix_text = res.perm_set_prefix;
        this.generate_permission_sets_text = res.generate_permission_sets;
        this.role_prefix_text = res.role_prefix;
        this.auto_create_roles_text = res.auto_create_roles;
        this.select_all_text = res.select_all;
        this.code_text = res.code;
        this.name_text = res.name;
      });
    } else {
      // Fallback if translation service is unavailable
      this.perm_set_prefix_text = 'Perm Set Prefix';
      this.generate_permission_sets_text = 'Generate Permission Sets';
      this.role_prefix_text = 'Role Prefix';
      this.auto_create_roles_text = 'Auto Create Roles';
      this.select_all_text = 'Select All';
      this.code_text = 'Code';
      this.name_text = 'Name';
    }
  }

  ngOnInit() {
    this.form = new FormGroup({
      permSetPrefix: new FormControl(''),
      rolePrefix: new FormControl(''),
      selectAll: new FormControl(),
    });
    this.store.select(PermWizardSelectors.selectPermWizard).subscribe(perm => {
      this.permissionTemplateGuid = perm.app_perm_template_hdr.guid.toString();
      this.targetTable = perm.app_perm_template_lines[0].target_options_json['default_target_hdr_table'];

      // The search model no longer carries a table: the search is expressed as
      // criteria against whichever of these three services is selected, and each
      // of CompanyUow / BranchUow / LocationUow understands the same
      // search_word / code_like / name_like / status criteria.
      if (this.targetTable == TARGET_TABLES.COMP){
        this.targetService = this.companyService;
      }
      else if (this.targetTable == TARGET_TABLES.BRANCH){
        this.targetService = this.branchService;
      }
      else if (this.targetTable == TARGET_TABLES.LOCATION){
        this.targetService = this.locationService;
      }

      this.columnsDefs  = [
        {
          headerName: this.code_text,
          field: this.targetTable + '.code',
          checkboxSelection: true,
          floatingFilter: true,
          cellStyle: {textAlign: 'left'},
        },
        {
          headerName: this.name_text,
          field: this.targetTable + '.name',
          floatingFilter: true,
          cellStyle: {textAlign: 'left'},
        },

      ];

   })
   }
   selectAllToggle(event) {
    console.log(event)
    console.log(event.checked)
    this.form.patchValue({
      selectAll: event.checked
    })
    if (this.form.controls["selectAll"].value == true) {
      // this.gridApi.selectAll()
      this.gridApi.forEachNode((row, index) => {
        this.gridApi.getRowNode(row.id).selectThisNode(true);
        console.log(this.gridApi.getSelectedRows())
      });
    } else {
      this.gridApi.deselectAll()
      console.log(this.gridApi.getSelectedRows())
    }
  }

  onNext() {
    this.permLine.emit();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.closeToolPanel();
    this.setGridData();
  }

  setGridData(){
    const datasource = {
      getRows: (grid) => {
        const filter = pageFiltering(grid.request.filterModel);
        const sortOn = pageSorting(grid.request.sortModel);
        // this.pagination.offset = this.SQLGuids ? 0 : grid.request.startRow;
        // this.pagination.limit = grid.request.endRow - grid.request.startRow;
        this.pagination.limit = 9999;
        this.pagination.conditionalCriteria = [
          { columnName: "calcTotalRecords", operator: "=", value: "true" },
          { columnName: "status", operator: "=", value: "ACTIVE" },
          ...this.searchCriteria,
        ];
        this.subs.sink = this.targetService
        .getByCriteria(this.pagination, this.apiVisa)
        // .get(this.apiVisa)
        .subscribe(
          (resolved) => {
            const data = sortOn(resolved.data).filter((entity) =>
              filter.by(entity)
            );
            const totalRecords = filter.isFiltering
              ? resolved.totalRecords
              : data.length;
            // const totalRecords = resolved.data.length
            grid.success({
              rowData: data,
              rowCount: totalRecords,
            });
          },
          (err) => {
            grid.fail();
          }
        );

      },
    };
    this.gridApi.setServerSideDatasource(datasource);
  }

  /**
   * Runs the search bar's query against the target listing's own endpoint.
   *
   * Replaces the raw SQL that <app-advanced-search> built from targetSearchModel
   * and posted to SubQueryService:
   *
   *   basic:    (hdr.code ILIKE '%x%' OR hdr.name ILIKE '%x%' AND hdr.status = 'ACTIVE')
   *   advanced: hdr.code ILIKE '%code%' AND hdr.name ILIKE '%name%'
   *             AND hdr.status = 'ACTIVE'
   *
   * over whichever of bl_fi_mst_comp / bl_fi_mst_branch / bl_inv_mst_location the
   * template targets. The search bar is now <app-advanced-search-general>, which
   * emits the keyword and the form value instead of SQL, and the criteria go to
   * the matching service. CompanyUow, BranchUow and LocationUow each apply
   * `search_word` as a bound ILIKE over code and name, `code_like` / `name_like`
   * per field, and `status`.
   *
   * The `AND hdr.status = 'ACTIVE'` scoping the old SQL carried is now applied on
   * every request in setGridData, not only when a search is active -- previously
   * the unsearched listing showed targets of any status.
   *
   * The grid pages server-side on these criteria now, instead of being handed a
   * fixed guid list to slice client-side.
   */
  onSearch(e: SearchQueryModel) {
    this.searchCriteria = this.buildSearchCriteria(e);
    this.gridApi.refreshServerSideStore();
  }

  buildSearchCriteria(e: SearchQueryModel): any[] {
    if (!e || e.isEmpty) {
      return [];
    }
    if (e.keyword) {
      return [{ columnName: 'search_word', operator: '=', value: e.keyword.trim() }];
    }
    const query: any = e.queryString || {};
    return [
      { columnName: 'code_like', operator: '=', value: (query.code || '').trim() },
      { columnName: 'name_like', operator: '=', value: (query.name || '').trim() }
    ].filter(condition => condition.value);
  }

  onGenerate(){
    console.log("GENERATE PERMISSION SETS")
    const selectedNodes: any[] = this.gridApi.getSelectedNodes();

    console.log("selectedNodes", selectedNodes);

    if(selectedNodes[0].data.bl_fi_mst_comp){
      this.companyGuid = [].concat(...selectedNodes.map(node => node.data.bl_fi_mst_comp)
      .flatMap(arr => arr.guid));
      console.log("companyGuid", this.companyGuid);
    }

    if(selectedNodes[0].data.bl_fi_mst_branch){
      this.branchGuid = [].concat(...selectedNodes.map(node => node.data.bl_fi_mst_branch)
      .flatMap(arr => arr.guid));
      console.log("branchGuid", this.companyGuid);
    }

    if(selectedNodes[0].data.bl_inv_mst_location){
      this.locationGuid = [].concat(...selectedNodes.map(node => node.data.bl_inv_mst_location)
      .flatMap(arr => arr.guid));
      console.log("locationGuid", this.companyGuid);
    }

    const permissionSetPrefix = this.form.controls['permSetPrefix'].value;
    const permissionSetrolePrefix = this.form.controls['rolePrefix'].value;
    const apiVisa = AppConfig.apiVisa;

    this.subs.sink = this.permissionWizardService.generatePermissions(this.autoCreate, this.permissionTemplateGuid,
      this.appletGuid, this.companyGuid, this.locationGuid, this.branchGuid, permissionSetrolePrefix,permissionSetPrefix,
      apiVisa).subscribe(data =>{
          this.toastr.success('Permissions generated successfully!');
        },
        error => {
          console.error(error);
          this.toastr.error('Failed to generate permissions!');
        }
      );

    // set target header guid and default target name
    // this.selectedPermSetLine.app_perm_set_line.target_hdr_guid = entity.guid;
    // this.selectedPermSetLine.default_target_hdr_name = entity[this.defaultViewField];

    // save updated perm set line in the store
    // this.store.dispatch(PermSetActions.selectPermSetLine({permSetLine: this.selectedPermSetLine}));

    // this.onReturn();
  }

  checkCheckBoxvalue(event){
    this.autoCreate = event.checked;
  }

  deletePerms() {
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
